/**
 * Export Button Component
 * CSV export functionality with loading state and permission checking
 */

import { Button, Modal } from 'antd';
import { useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../store/hooks';
import { exportReport } from '../../../store/dashboardSlice';

interface ExportButtonProps {
  className?: string;
}

function ExportButton({ className }: ExportButtonProps) {
  const dispatch = useAppDispatch();
  const { filters, loading } = useAppSelector(state => state.dashboard);
  const exportPermission = useAppSelector(state => state.dashboard.info?.export_permission);
  const [showModal, setShowModal] = useState(false);

  const handleExport = () => {
    setShowModal(true);
  };

  const handleOk = () => {
    setShowModal(false);
    dispatch(exportReport(filters));
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  // Don't render if user doesn't have export permission
  if (!exportPermission) {
    return null;
  }

  return (
    <>
      <Button
        type="primary"
        danger
        loading={loading.export}
        onClick={handleExport}
        className={`tec-button-md tec-button-red ${className || ''}`}
        size="large"
      >
        Export
      </Button>
      
      <Modal
        title="Please Wait"
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="OK"
        cancelText="Cancel"
        maskClosable={false}
        style={{ zIndex: 9999 }}
      >
        <div>
          <h3>Your report may not appear automatically.</h3>
          <p>
            If your report does not download within a few seconds, it will be scheduled to run later.
          </p>
          <p>
            Please check the <a href='/reports/#/list/generate/run_report_list'>Report List</a> later.
          </p>
        </div>
      </Modal>
    </>
  );
}

export default ExportButton;